import React, { useEffect, useState } from 'react';
import { FiUsers, FiPackage, FiAlertTriangle, FiTruck } from 'react-icons/fi';
import axios from 'axios';

const BusinessDashboardCards = () => {
  const [stats, setStats] = useState({
    activeUsers: "",
    totalOrders: null,
    lowStockAlerts: null,
    pendingDeliveries: null,
  });
  const [loading, setLoading] = useState(true);

  const user = JSON.parse(localStorage.getItem('user'))
  const name = user.firstName

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get('https://citi-mobile-app.onrender.com/businessmanager/dashboard-stats');
        setStats(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching dashboard stats:', error);
      }
    };
    
    fetchStats();
  }, []);

  const cards = [
    {
      icon: <FiUsers className="text-purple-600" size={30} />,
      title: 'Active Users',
      value: stats.activeUsers,
      loading: loading,
    },
    {
      icon: <FiPackage className="text-purple-600" size={30} />,
      title: 'Total Orders',
      value: stats.totalOrders,
      loading: loading,
    },
    {
      icon: <FiAlertTriangle className="text-purple-600" size={30} />,
      title: 'Low Stock Alerts',
      value: stats.lowStockAlerts,
      loading: loading,
    },
    {
      icon: <FiTruck className="text-purple-600" size={30} />,
      title: 'Pending Deliveries',
      value: stats.pendingDeliveries,
      loading: loading,
    },
  ];

  return (
    <div className='flex-row mt-20 ml-60 max-sm:ml-0 max-sm:bg-white '>
         <h1 className=' text-[#1E1E1E] font-bold mt-16'>Welcome back {name}</h1>
         <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-5">
  {cards.map((card, index) => (
    <div 
      key={index} 
      className="bg-white shadow-md rounded-lg p-6 flex flex-col items-start justify-between">
      <div className="flex items-center space-x-4">
        {card.icon}
        <div>
          <p className="text-gray-600 text-sm">{card.title}</p>
          {card.loading ? (
            <p>Loading...</p>
          ) : (
            <h2 className="text-3xl font-bold">{card.value}</h2>
          )}
        </div>
      </div>
    </div>
  ))}
</div>

    </div>
   
  );
};

export default BusinessDashboardCards;
